module.exports = __webpack_public_path__ + "static/media/img.logo.72c0f422.svg";


//////////////////
// WEBPACK FOOTER
// ./src/display/modules/Home/PreviewPublic/Components/Icon/img.logo.svg
// module id = 6664
// module chunks = 0